module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": _vm.item.url
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.featured_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.url
    }
  }, [_c('h3', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), (_vm.item.compare_at_price > _vm.item.price) ? [_c('span', [_vm._v("$ " + _vm._s(_vm._f("money")(_vm.item.compare_at_price)))]), _vm._v(" "), _c('span', [_vm._v("$ " + _vm._s(_vm._f("money")(_vm.item.price)) + " on sale !")])] : [_c('span', [_vm._v("$ " + _vm._s(_vm._f("money")(_vm.item.price)))])], _vm._v(" "), (_vm.item.available == false) ? _c('span', [_vm._v(_vm._s(_vm.i18n.sold_out))]) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c732620", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c732620","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductGridTile.vue
// module id = 55
// module chunks = 0